import { Component } from "@angular/core";

@Component({
  selector: "app-recaptcha-notice",
  templateUrl: "./recaptcha-notice.component.html",
  styleUrls: ["./recaptcha-notice.component.scss"],
})
export class RecaptchaNoticeComponent {}
